var _g, _line, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgComplexityHierarchy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 32,
    y1: 54,
    x2: 18,
    y2: 40
  }), /*#__PURE__*/React.createElement("line", {
    x1: 32,
    y1: 54,
    x2: 46,
    y2: 40
  }), /*#__PURE__*/React.createElement("line", {
    x1: 18,
    y1: 40,
    x2: 10,
    y2: 24
  }), /*#__PURE__*/React.createElement("line", {
    x1: 18,
    y1: 40,
    x2: 32,
    y2: 24
  }), /*#__PURE__*/React.createElement("line", {
    x1: 46,
    y1: 40,
    x2: 32,
    y2: 24
  }), /*#__PURE__*/React.createElement("line", {
    x1: 46,
    y1: 40,
    x2: 54,
    y2: 24
  }), /*#__PURE__*/React.createElement("line", {
    x1: 10,
    y1: 24,
    x2: 10,
    y2: 12
  }), /*#__PURE__*/React.createElement("line", {
    x1: 32,
    y1: 24,
    x2: 32,
    y2: 12
  }), /*#__PURE__*/React.createElement("line", {
    x1: 54,
    y1: 24,
    x2: 54,
    y2: 12
  }))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 6,
    y1: 10,
    x2: 58,
    y2: 10,
    strokeWidth: 3
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#ffffff",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 54,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 40,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 46,
    cy: 40,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 24,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 24,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 54,
    cy: 24,
    r: 3
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComplexityHierarchy);
export default __webpack_public_path__ + "static/media/complexity-hierarchy.250a4083dcc158bb274d737f1fb3054b.svg";
export { ForwardRef as ReactComponent };